import { render, staticRenderFns } from "./tgjRasPlatform.vue?vue&type=template&id=e73165f0&"
import script from "./tgjRasPlatform.vue?vue&type=script&lang=js&"
export * from "./tgjRasPlatform.vue?vue&type=script&lang=js&"
import style0 from "./tgjRasPlatform.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-gov-report/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e73165f0')) {
      api.createRecord('e73165f0', component.options)
    } else {
      api.reload('e73165f0', component.options)
    }
    module.hot.accept("./tgjRasPlatform.vue?vue&type=template&id=e73165f0&", function () {
      api.rerender('e73165f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ent/tgjRasPlatform.vue"
export default component.exports